import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLayoutProfile = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.125 3.125H3.875C3.46016 3.125 3.125 3.46016 3.125 3.875V21.125C3.125 21.5398 3.46016 21.875 3.875 21.875H21.125C21.5398 21.875 21.875 21.5398 21.875 21.125V3.875C21.875 3.46016 21.5398 3.125 21.125 3.125ZM4.8125 4.8125H8V20.1875H4.8125V4.8125ZM20.1875 20.1875H9.5V9.5H20.1875V20.1875ZM9.5 8V4.8125H20.1875V8H9.5Z",
		fill: "currentColor"
	})
});
export default SvgLayoutProfile;
